import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from './assets/VE_Symbol.png'


const _hoisted_1 = { class: "mr-auto px-2 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "relative flex h-16 items-center justify-between" }
const _hoisted_3 = { class: "absolute inset-y-0 left-0 flex items-center sm:hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-0.5" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_6 = { class: "flex flex-1 items-center justify-center sm:items-stretch sm:justify-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-9 w-auto",
  src: _imports_0,
  alt: "Hyper"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white font-semibold text-lg" }, "hyper", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-lg" }, "Layer", -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "hidden sm:ml-6 sm:block" }
const _hoisted_12 = { class: "flex space-x-4" }
const _hoisted_13 = ["onClick", "aria-current"]
const _hoisted_14 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0" }
const _hoisted_15 = {
  key: 0,
  class: "text-white text-base font-light"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-1.5" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 w-8 rounded-full",
  src: "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png",
  alt: ""
}, null, -1)
const _hoisted_19 = { class: "space-y-1 px-2 pb-3 pt-2" }
const _hoisted_20 = {
  class: "h-full w-full",
  style: {"scrollbar-width":"thin"}
}

import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

import { watch,ref } from 'vue'
import { authStore } from "./store/index";
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const auth = authStore();
let tokenValid = ref(auth.tokenValid);
const router = useRouter()


watch(tokenValid, () => {
  if (tokenValid.value) {
    router.push("/")
  }else{
    router.push("/")
  }
})

const navigation = [
  { name: 'Stats Search', href: '/statsearch', current: false },
  { name: 'VScore', href: '/vscore/match', current: false },
  { name: 'Game Manager', href: '/gameManager', current: false },
  { name: 'Officiating', href: '#', current: false },
]


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(auth).user && _unref(auth).tokenValid == true)
      ? (_openBlock(), _createBlock(_unref(Disclosure), {
          key: 0,
          as: "nav",
          class: "bg-gray-800 top-0 w-full fixed z-10"
        }, {
          default: _withCtx(({ open }) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(DisclosureButton), { class: "relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5,
                      (!open)
                        ? (_openBlock(), _createBlock(_unref(Bars3Icon), {
                            key: 0,
                            class: "block h-6 w-6",
                            "aria-hidden": "true"
                          }))
                        : (_openBlock(), _createBlock(_unref(XMarkIcon), {
                            key: 1,
                            class: "block h-6 w-6",
                            "aria-hidden": "true"
                          }))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "flex flex-shrink-0 items-center",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/'))),
                    style: {"cursor":"pointer"}
                  }, _hoisted_10),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                        return _createElementVNode("a", {
                          style: {"cursor":"pointer"},
                          key: item.name,
                          onClick: ($event: any) => (_unref(router).push(item.href)),
                          class: _normalizeClass([item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'rounded-md px-3 py-2 text-sm font-medium']),
                          "aria-current": item.current ? 'page' : undefined
                        }, _toDisplayString(item.name), 11, _hoisted_13)
                      }), 64))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_unref(auth).user && _unref(auth).tokenValid == true)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_15, _toDisplayString(_unref(auth).user.profile.given_name), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Menu), {
                    as: "div",
                    class: "relative ml-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(MenuButton), { class: "relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800" }, {
                          default: _withCtx(() => [
                            _hoisted_16,
                            _hoisted_17,
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(MenuItem), null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("a", {
                                    href: "/profile",
                                    class: _normalizeClass([active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'])
                                  }, "Your Profile", 2)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(MenuItem), null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: _normalizeClass([active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'])
                                  }, "Settings", 2)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(MenuItem), null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: _normalizeClass([active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']),
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(auth).logout();})
                                  }, "Sign out", 2)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createVNode(_unref(DisclosurePanel), { class: "sm:hidden" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                    return _createVNode(_unref(DisclosureButton), {
                      key: item.name,
                      as: "a",
                      href: item.href,
                      class: _normalizeClass([item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'block rounded-md px-3 py-2 text-base font-medium']),
                      "aria-current": item.current ? 'page' : undefined
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["href", "class", "aria-current"])
                  }), 64))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_RouterView)
    ])
  ], 64))
}
}

})